module.exports = __webpack_public_path__ + "img/questionnaireBtn.6029a778.png";